import {
    Button,
    Cell,
    PageTitle,
    Row,
    StyleFunction,
    Surface,
    Table,
    useThemedStyle,
} from "@venuepos/react-common";
import React from "react";
import { useTranslation } from "locales";
import { RootStackScreenProps } from "../../navigation";
import { AdminContainer } from "../container";

type ScreenProps = RootStackScreenProps<"TASKS_AND_JOBS">;

export function TasksAndJobsScreen({ navigation: { navigate } }: ScreenProps) {
    const styles = useThemedStyle(styleFunc);
    const [t] = useTranslation();

    return (
        <AdminContainer>
            <PageTitle>
                {t(
                    "backoffice.graphs_and_stats.graphs_and_stats",
                    "Graphs and stats"
                )}
            </PageTitle>
            <Surface>
                <Table>
                    <Row style={styles.row}>
                        <Cell>
                            <Button
                                onPress={() => {
                                    navigate("TASK_RESULT_LIST");
                                }}
                            >
                                {t(
                                    "backoffice.tasks_and_jobs.task_result_list",
                                    "Task results"
                                )}
                            </Button>
                        </Cell>
                    </Row>
                    <Row style={styles.row}>
                        <Cell>
                            <Button
                                onPress={() => {
                                    navigate("SAFT_JOBS");
                                }}
                            >
                                {t(
                                    "backoffice.tasks_and_jobs.saft_jobs",
                                    "SAF-T jobs"
                                )}
                            </Button>
                        </Cell>
                    </Row>
                    <Row style={styles.row}>
                        <Cell>
                            <Button
                                onPress={() => {
                                    navigate("ECONOMIC_SYNC_JOBS");
                                }}
                            >
                                {t(
                                    "backoffice.tasks_and_jobs.economic_sync_jobs",
                                    "E-conomic sync jobs"
                                )}
                            </Button>
                        </Cell>
                    </Row>
                </Table>
            </Surface>
        </AdminContainer>
    );
}

const styleFunc: StyleFunction = theme => ({
    row: {
        paddingVertical: theme.spacingScale,
    },
});
